<template>
  <v-dialog persistent v-model="closeTicketDialog" max-width="500">
    <v-card class="pa-3">
      <v-card-title class="headline pl-0 pt-0"> Close Ticket </v-card-title>
      <v-form ref="form">
        <div v-if="!isTechnicianMode">
          <v-card-text class="font-weight-bold">
            Please let us know why you are closing this ticket.
            <br />
            You can select an option or enter your own (optional).
          </v-card-text>
          <v-radio-group v-model="closeReasonSelect" class="mt-0">
            <v-radio
              class="font-weight-bold"
              v-for="n in closeReasons()"
              :key="n"
              :label="`${n}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </div>
        <div v-else class="mb-3">
          <v-layout>
            <v-flex xs6 sm5 class="mr-2">
              <v-select
                v-model="acknowledge"
                :items="[...acknowledgeList]"
                label="Acknowledge"
                ref="acknowledge"
                :rules="[rules.required]"
              ></v-select>
            </v-flex>
            <v-flex xs6 sm6>
              <v-select
                :disabled="technicianId != null"
                v-model="technicianName"
                :items="[...techniciansNameList]"
                label="Technician"
                ref="technician"
                :rules="[rules.required]"
              ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-flex xs8 class="mt-0">
          <v-Textarea
            rows="3"
            outline
            :rules="isTechnicianMode ? [rules.required] : []"
            v-model="closeReasonMessage"
            :label="
              isTechnicianMode == true
                ? 'Resolution'
                : 'why you are closing the ticket? (optional).'
            "
            ref="closeReasonMessage"
          ></v-Textarea>
        </v-flex>
        <v-card-text
          class="pa-0 ma-0 mb-2"
          style="font-size: 13px"
          v-if="!isTechnicianMode"
        >
          Your input is not tracked, we only use it to help improve future
          problem-solving.
        </v-card-text>

        <v-card-actions class="mr-0 mt-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark small @click="resetCloseTicketDialog()">
            cancel
          </v-btn>
          <v-btn
            :loading="processing"
            color="success"
            small
            @click="closeTicket()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  async created() {
    this.request = this.initialData.request;
    this.isTechnicianMode = this.initialData.technician;
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    value: {
      immediate: true,
      async handler(val) {
        this.closeTicketDialog = val;
        if (val == true) {
          this.technicianName = this.request.technicianName || "";
          this.technicianId = this.request.technicianID || null;
          if (this.isTechnicianMode) {
            const acknowledge = await this.getAcknowledgeList();
            this.acknowledgeList = acknowledge.udf_char3.map(
              (c) => c.display_value
            );

            this.manageengineTechnicians = await this.gettechniciansNameList();
            this.techniciansNameList = this.manageengineTechnicians.technician.map(
              (c) => c.name
            );
          }
        }
      },
    },
    closeTicketDialog(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    closeTicketDialog: false,
    closeReasonSelect: "",
    closeReasonMessage: "",
    request: "",
    processing: false,
    acknowledge: "",
    acknowledgeList: "",
    technicianName: "",
    technicianId: null,
    techniciansNameList: "",
    manageengineTechnicians: [],
    isTechnicianMode: Boolean,
    isTechAothAssigned: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
  }),
  methods: {
    closeReasons() {
      const list = [
        "Issue resolved independently",
        "Issue no longer relevant",
        "Internal decision",
      ];
      return list;
    },
    resetCloseTicketDialog() {
      this.closeTicketDialog = false;
      this.closeReasonSelect = null;
      this.closeReasonMessage = null;
      this.acknowledge = "";
      this.$refs.form.resetValidation(true);
    },
    async closeTicket() {
      if (!this.$refs.form.validate(true)) {
        return;
      }

      if (this.isTechnicianMode) {
        const manageengineTechnician = this.manageengineTechnicians.technician.find(
          (t) => t.name == this.technicianName
        );
        this.technicianId = manageengineTechnician.id;
      } else if (!this.technicianId) {
        this.technicianId = "24078000032975895"; //userPortal
        this.isTechAothAssigned = true;
      }

      const closeReason = !this.isTechnicianMode
        ? this.closeReasonSelect || this.closeReasonMessage
          ? `<b>The ticket was closed by ${
              this.$store.state.authentication.user
            } <br> provided resolution/reason: </b> ` +
            (this.closeReasonSelect ? this.closeReasonSelect + ", " : "") +
            " " +
            (this.closeReasonMessage ? this.closeReasonMessage : "")
          : `The ticket was closed by ${
              this.$store.state.authentication.user
            } without providing a resolution/reason`
        : this.closeReasonMessage;

      try {
        this.processing = true;
        await this.$http.put("api/manageengine/EditTicket", {
          StatusName: "Closed",
          Acknowledge: this.acknowledge || "Ignored",
          Resolution: closeReason,
          TechnicianId: this.technicianId,
          ManageengineID: this.request.manageengineID,
          DisplayID: this.request.displayID,
          Category: this.request.categoryName || "Untitled",
        });
        console.log(this.isTechAothAssigned);
        if (this.isTechAothAssigned) {
          await this.$http.put("api/manageengine/EditTicket", {
            TechnicianId: "clear",
            ManageengineID: this.request.manageengineID,
            DisplayID: this.request.displayID,
          });
        }
        this.$emit("tickedClosed");

        this.conversationList = null;
        this.loadAllConversationsBtn = false;
        this.$notify({
          group: "notification",
          text: "Ticked Closed",
          type: "success",
        });
        this.resetCloseTicketDialog();
        this.processing = false;
      } catch (e) {
        this.processing = false;
      }
    },
    async getAcknowledgeList() {
      try {
        return await this.$http.get("api/manageengine/getAcknowledgeList");
      } catch (error) {
        console.error(error);
      }
    },
    async gettechniciansNameList() {
      try {
        return await this.$http.get("api/manageengine/getTechnicians");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
